import { EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import BlogPlanningImage from '@/assets/trips/claims-guide/blog-planning.png';
import BlogUlitmateguideImage from '@/assets/trips/claims-guide/blog-ulitmateguide.png';
import CampingChecklistImage from '@/assets/trips/claims-guide/camping-checklist.png';
import ClampingGuideImage from '@/assets/trips/claims-guide/clamping-guide.png';
import FallGuideImage from '@/assets/trips/claims-guide/fall-guide.png';
import LocZionImage from '@/assets/trips/claims-guide/loc-zion.png';
import StartSlideImage from '@/assets/trips/claims-guide/start.jpeg';
import SummerGuideImage from '@/assets/trips/claims-guide/summer-guide.png';
import WinterGuideImage from '@/assets/trips/claims-guide/winter-guide.png';
import { ArrowVariants } from '@/components/switchback/Carousel/Arrow';
import Carousel, { Spacing } from '@/components/switchback/Carousel/Carousel';
import { useBreakpoint } from '@/hooks/useBreakpoint';

import { TripGuide } from './TripGuide';

export const TripGuideContainer = () => {
  const intl = useIntl();
  const { isAboveDesktop } = useBreakpoint();

  const guides = useMemo(
    () => [
      {
        href: '/guide/seasonal/winter',
        title: intl.formatMessage({
          defaultMessage: 'Winter Travel Guide 2024',
          id: '1zYEvm',
        }),
        image: WinterGuideImage,
      },
      {
        href: '/trips?modal=claims-guide',
        title: intl.formatMessage({
          defaultMessage: 'Avoid these top 5 RV Mishaps',
          id: 'szZlxN',
        }),
        image: StartSlideImage,
      },
      {
        href: '/guide/seasonal/fall',
        title: intl.formatMessage({
          defaultMessage: 'Fall Travel Guide 2024',
          id: 'TgM899',
        }),
        image: FallGuideImage,
      },
      {
        href: 'https://www.outdoorsy.com/blog/5-underrated-things-to-pack-for-your-next-trip',
        title: intl.formatMessage({
          defaultMessage: '5 Underrated Things To Pack',
          id: '7i8am7',
        }),
        image: BlogPlanningImage,
      },
      {
        href: 'https://www.outdoorsy.com/blog/ultimate-resource-guide-for-rvers',
        title: intl.formatMessage({
          defaultMessage: 'Ultimate Resource Guide for RVers',
          id: 'pfccMQ',
        }),
        image: BlogUlitmateguideImage,
      },
      {
        href: '/guide/seasonal/summer',
        title: intl.formatMessage({
          defaultMessage: 'Summer Travel Guide 2024',
          id: 'R0aZj9',
        }),
        image: SummerGuideImage,
      },
      {
        href: 'https://www.outdoorsy.com/guide/yosemite-national-park',
        title: intl.formatMessage({
          defaultMessage: 'Your Yosemite National Park Guide',
          id: '4BLV+J',
        }),
        image: LocZionImage,
      },
      {
        href: 'https://www.outdoorsy.com/blog/outdoorsys-guide-to-glamping',
        title: intl.formatMessage({
          defaultMessage: 'Outdoorsy’s Glamping Guide',
          id: 'epSQ2s',
        }),
        image: ClampingGuideImage,
      },
      {
        href: 'https://www.outdoorsy.com/blog/camping-checklist',
        title: intl.formatMessage({
          defaultMessage: 'Your Camping Checklist',
          id: 'JOBI4m',
        }),
        image: CampingChecklistImage,
      },
    ],
    [intl],
  );

  return (
    <div className="mb-8 bg-white">
      <Heading variant={EHeadingStyleVariant.H6}>
        <FormattedMessage defaultMessage="Trip guides" id="QDCg1o" />
      </Heading>

      {isAboveDesktop && (
        <div className="mt-4">
          <Carousel
            arrows={true}
            componentName="dynamic-rentals-carousel"
            className="bg-white"
            slidesToShow={6}
            slidesToScroll={1}
            hasShadow={false}
            spacing={Spacing.large}
            infinite={false}
            swipeToSlide={true}
            arrowVariant={ArrowVariants.inside}>
            {guides.map((guide, index) => (
              <TripGuide key={index} href={guide.href} title={guide.title} image={guide.image} />
            ))}
          </Carousel>
        </div>
      )}

      {!isAboveDesktop && (
        <div className="flex py-2 mt-2 overflow-x-auto bg-white gap-5">
          {guides.map(guide => (
            <div key={guide.title} className="flex-shrink-0 w-[calc(100%/2.44)]">
              <TripGuide href={guide.href} title={guide.title} image={guide.image} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
